import React, { useState, useEffect } from "react";

import API from '../../tools/API';
import AddTagModal from "../../components/Modal/AddTagModal";
import Modal from "../../components/Modal/Modal";

import styles from "./Tags.module.scss";
import RemoveTag from "../../components/Modal/RemoveTag";

interface Response {
    id: number,
    name: string
}

const Tags = () => {
    const [categories, setCategories] = useState<Response[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [removeTagModal, setRemoveTagModal] = useState<number | boolean>(false);

    useEffect(() => {
        if (!showModal) {
            API.getListOfTags().then(res => setCategories(res?.data.data));
        }
    }, [showModal, removeTagModal]);

    return (
        <div className={styles.tags}>
            <div className={styles.topRow}>
                <button
                    className={styles.tagsBtn}
                    onClick={(e) => {
                        e.preventDefault();
                        setShowModal(true);
                    }
                    }><div className={styles.addIcon}></div>Dodaj tag</button>
            </div>
            <div className={styles.bottomRow}>
                <h2 className={styles.tagsHeader}>
                    Lista tagów
                </h2>
            </div>
            <div className={styles.tagsWrapper}>
                <ul className={styles.tagsList}>
                    {categories &&
                        categories.map((el, i) => (
                            <div className={styles.listElementWrapper} key={i}>
                                <li className={styles.listElement}>{el.name}</li>
                                <div
                                    className={styles.deleteBtn}
                                    onClick={
                                        () => {
                                            setRemoveTagModal(el.id);
                                        }
                                    }
                                >
                                </div>
                            </div>
                        ))}
                </ul>
            </div>
            {showModal && (
                <Modal openModal={setShowModal}>
                    <AddTagModal openModal={setShowModal} />
                </Modal>
            )
            }
            {removeTagModal &&
                <Modal openModal={setRemoveTagModal}>
                    <RemoveTag id={removeTagModal} setCategories={setCategories} openModal={setRemoveTagModal} />
                </Modal>

            }
        </div>
    )
}

export default Tags;